module.exports = __webpack_public_path__ + "static/media/upArrow.5bb9d3e7.svg";